import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { EmptyIterator_instancex3sopkoseugu as EmptyIterator_instance } from '../collections/CollectionsKt.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { ConstrainedOnceSequence3d7vfvt49occh as ConstrainedOnceSequence } from './sequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generateSequence(seed, nextFunction) {
  var tmp;
  if (seed == null) {
    tmp = EmptySequence_instance;
  } else {
    tmp = new (GeneratorSequence())(() => seed, nextFunction);
  }
  return tmp;
}
function generateSequence_0(nextFunction) {
  return constrainOnce(new (GeneratorSequence())(nextFunction, (it) => nextFunction()));
}
function emptySequence() {
  return EmptySequence_instance;
}
var DropTakeSequenceClass;
function DropTakeSequence() {
  if (DropTakeSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTakeSequence');
    DropTakeSequenceClass = $;
  }
  return DropTakeSequenceClass;
}
var TakeSequence$iterator$1Class;
function TakeSequence$iterator$1() {
  if (TakeSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.left_1 = this$0.count_1;
        this.iterator_1 = this$0.sequence_1.iterator_jk1svi_k$();
      }
      next_20eer_k$() {
        if (this.left_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        this.left_1 = this.left_1 - 1 | 0;
        return this.iterator_1.next_20eer_k$();
      }
      hasNext_bitz1p_k$() {
        return this.left_1 > 0 && this.iterator_1.hasNext_bitz1p_k$();
      }
    }
    initMetadataForClass($);
    TakeSequence$iterator$1Class = $;
  }
  return TakeSequence$iterator$1Class;
}
var TakeSequenceClass;
function TakeSequence() {
  if (TakeSequenceClass === VOID) {
    class $ {
      constructor(sequence, count) {
        this.sequence_1 = sequence;
        this.count_1 = count;
        // Inline function 'kotlin.require' call
        if (!(this.count_1 >= 0)) {
          var message = 'count must be non-negative, but was ' + this.count_1 + '.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      take_6gva4v_k$(n) {
        return n >= this.count_1 ? this : new (TakeSequence())(this.sequence_1, n);
      }
      iterator_jk1svi_k$() {
        return new (TakeSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeSequence', VOID, VOID, [DropTakeSequence()]);
    TakeSequenceClass = $;
  }
  return TakeSequenceClass;
}
var EmptySequenceClass;
function EmptySequence() {
  if (EmptySequenceClass === VOID) {
    class $ {
      iterator_jk1svi_k$() {
        return EmptyIterator_instance;
      }
      take_6gva4v_k$(n) {
        return EmptySequence_instance;
      }
    }
    initMetadataForObject($, 'EmptySequence', VOID, VOID, [DropTakeSequence()]);
    EmptySequenceClass = $;
  }
  return EmptySequenceClass;
}
var EmptySequence_instance;
function EmptySequence_getInstance() {
  return EmptySequence_instance;
}
function calcNext($this) {
  $this.nextItem_1 = $this.nextState_1 === -2 ? $this.this$0__1.getInitialValue_1() : $this.this$0__1.getNextValue_1(ensureNotNull($this.nextItem_1));
  $this.nextState_1 = $this.nextItem_1 == null ? 0 : 1;
}
var GeneratorSequence$iterator$1Class;
function GeneratorSequence$iterator$1() {
  if (GeneratorSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.nextItem_1 = null;
        this.nextState_1 = -2;
      }
      next_20eer_k$() {
        if (this.nextState_1 < 0) {
          calcNext(this);
        }
        if (this.nextState_1 === 0)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this.nextItem_1;
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.nextState_1 = -1;
        return result;
      }
      hasNext_bitz1p_k$() {
        if (this.nextState_1 < 0) {
          calcNext(this);
        }
        return this.nextState_1 === 1;
      }
    }
    initMetadataForClass($);
    GeneratorSequence$iterator$1Class = $;
  }
  return GeneratorSequence$iterator$1Class;
}
var GeneratorSequenceClass;
function GeneratorSequence() {
  if (GeneratorSequenceClass === VOID) {
    class $ {
      constructor(getInitialValue, getNextValue) {
        this.getInitialValue_1 = getInitialValue;
        this.getNextValue_1 = getNextValue;
      }
      iterator_jk1svi_k$() {
        return new (GeneratorSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'GeneratorSequence');
    GeneratorSequenceClass = $;
  }
  return GeneratorSequenceClass;
}
function constrainOnce(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ConstrainedOnceSequence()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (ConstrainedOnceSequence())(_this__u8e3s4);
  }
  return tmp;
}
//region block: init
EmptySequence_instance = new (EmptySequence())();
//endregion
//region block: exports
export {
  DropTakeSequence as DropTakeSequence18qfczyunxcax,
  TakeSequence as TakeSequencecj2mz1r3ww35,
  emptySequence as emptySequence25zpp7hgtqwdd,
  generateSequence as generateSequence118suk3hffuuw,
  generateSequence_0 as generateSequence3b5pkcqrpr2fo,
};
//endregion

//# sourceMappingURL=Sequences.mjs.map
